module.exports = __webpack_public_path__ + "23_bigdata_2.jpg?011fd1ae56aafbe447b69e0d339631b2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/23_bigdata_2.jpg
// module id = 193
// module chunks = 0